/**
 * Returns the default values for a new clinic
 */
export const createDefaultClinic = () => {
  return {
    isActive: true,
    clinicBookings: true,
    homeVisits: true,
    telehealth: true,
    vitalsMonitoring: true,
    walkIns: true,
    name: null,
    province: null,
    address: null,
    physicalAddress: null,
    clinicType: 'Medical Facility',
    place_id: null,
    practiceName: null,
    practiceRegNumber: null,
    practiceNumber: null,
    phoneNumber: null,
    // Billing Profile defaults
    billingPracticeName: null,
    disciplineType: 'GP Standard',
    disciplinePrefix: '014',
    roomsDefault: null,
    network: false,
    ipa: false,
    dispensing: false,
    schemeContracts: [],
    // Services Offered defaults - Adding mock data for testing
    servicesOffered: [],
    // Service Configurations defaults
    serviceConfigurations: {},
    servicesConfig: [],
    bpmConfig: []
  }
}
